import React, { useEffect, useState } from 'react';

// Floating "back to top" button. Robust across the site's two scroll setups — the
// Home page scrolls the window, the other pages scroll <body> (global CSS) — by
// reading every scroll source and scrolling them all to the top.
const getScrollTop = () =>
  window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(getScrollTop() > 500);
    onScroll();
    // capture:true so a scroll on <body> (not the window) is still caught.
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    return () => window.removeEventListener('scroll', onScroll, true);
  }, []);

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (document.scrollingElement) document.scrollingElement.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Back to top"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full text-white shadow-[0_10px_28px_rgba(10,132,255,0.4)] transition-all duration-300 hover:-translate-y-1 ${
        visible ? 'opacity-100' : 'pointer-events-none translate-y-3 opacity-0'
      }`}
      style={{ background: 'linear-gradient(135deg, #4ade80, #0a84ff)' }}
    >
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M12 19V5M6 11l6-6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
};

export default BackToTop;
